<template>
  <div class="app-container">
    <div class="">
      <!-- <div class="detailsTitle">
        <h4>入库计划</h4>
      </div> -->
      <!-- 查询条件 -->
      <div class="formBox margbot" ref="searchBox">
        <el-form :inline="true" :model="formData" class="demo-form-inline" label-width="90px" ref="formData" size="mini">
          <el-form-item label="车辆号牌:">
            <el-input v-model="formData.instockPlateNumber" placeholder="请输入车号" style="width: 175px;"></el-input>
          </el-form-item>
          <el-form-item label="一级货主:">
            <el-select style="width: 175px;" v-model="formData.primaryCustomerTaxId" placeholder="请选择货主" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName" :value="item.taxpayerNumber"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级货主:">
            <el-select style="width: 175px;" v-model="formData.customerTaxId" placeholder="请选择货主" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName" :value="item.taxpayerNumber"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间:">
            <el-date-picker v-model="formData.createTimeStart" type="date" placeholder="选择创建日期" value-format="yyyy-MM-dd" style="width: 175px;"></el-date-picker>
            -
            <el-date-picker v-model="formData.createTimeEnd" placeholder="选择创建日期" type="date" value-format="yyyy-MM-dd" style="width: 175px;"></el-date-picker>
          </el-form-item>
          <el-form-item label="司机姓名:">
            <el-input v-model="formData.driverName" placeholder="请输入司机名" style="width: 175px;"></el-input>
          </el-form-item>
          <el-form-item label="入库单号:">
            <el-input v-model="formData.instockNo" placeholder="请输入入库单号" style="width: 175px;"></el-input>
          </el-form-item>
          <el-form-item label="到货方式:">
            <el-select style="width: 175px;" v-model="formData.arrivalMethod" clearable placeholder="请选择" filterable>
              <el-option v-for="(item, index) in arrivalMethodData" :key="index" :label="item.label" :value="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          <br />
          <el-form-item style="padding:5px 0 5px 5px;">
            <el-button type="primary" size="mini" @click="xinzeng" btnCode="00ZP001B001" v-if="btnFlg[0]">新增</el-button>
            <el-button type="primary" size="mini" @click="xiugai" btnCode="00ZP001B002" v-if="btnFlg[1]">修改</el-button>
            <el-button type="primary" size="mini" @click="shanchu" btnCode="00ZP001B003" v-if="btnFlg[2]">删除</el-button>
            <el-button type="primary" size="mini" @click="chaxun" btnCode="00ZP001B004" v-if="btnFlg[3]">查询</el-button>
            <el-button type="primary" size="mini" @click="chongzhi" btnCode="00ZP001B005" v-if="btnFlg[4]">重置</el-button>
            <el-button type="primary" size="mini" @click="dayin" btnCode="00ZP001B006" v-if="btnFlg[5]">打印</el-button>
            <!-- 首线联合打印20241227 -->
            <el-button type="primary" size="mini" @click="dayin(1)"  v-if="btnFlg[8]">打印</el-button>
            <el-button type="primary" size="mini" @click="daochu" btnCode="00ZP001B008" v-if="btnFlg[7]">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 表格 -->
      <div :style="{ height: h }">
        <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData" style="width: 100%" class="tableComent" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row @row-click="dianjixuanzhong">
          <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
          <el-table-column align="center" label="操作" width="80">
            <template slot-scope="scope">
              <el-button type="text" @click="lookImg(scope.row)" size="mini">查看单据</el-button>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="instockNo" label="入库单号" align="center" width="220"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="车号" align="center" width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center" width="220"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center" width="220"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机姓名" align="center" width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" align="center" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号" align="center" width="150"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="arrivalMethod" label="到货方式" align="center" width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="vehicleNumber" label="车船号" align="center" width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" align="center" width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" align="center" width="180" :formatter="dateTimeFormat"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="ext1" label="备注" align="center" width="150"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="warehousingNo" label="出厂编号" align="center" width="150"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号" align="center" width="150"></el-table-column>
        </el-table>
      </div>
      <div class="pags" style="text-align: right">
        <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
      </div>
      <div class="market_out">
        <div class="detailsTitle">
          <h4>货物详情</h4>
        </div>
        <!--货物详情-->
        <div>
          <div ref="searchBox2" style="margin-bottom:5px;margin-left:10px;">
            <el-button type="primary" size="mini" @click="xc" btnCode="00ZP001B007" v-if="btnFlg[6]">确认入库</el-button>
            <span>
              总吨数:
              <span style="color: red">{{ totalAllWeight }}</span> &nbsp;吨
            </span>
            <span style="margin-left: 15px">
              总件数:
              <span style="color: red">{{ totalNumber }}</span> &nbsp;件
            </span>
          </div>
          <!--详情表格-->
          <div class="ruKuZuoyeWarp-body-detailsTab">
            <div class="" :style="{ height: detailsH }">
              <el-table height="100%" size="mini" ref="tabref" :data="detailsData" style="width: 100%" :header-cell-style="{ background: '#F5F5F5', color: 'black',}" highlight-current-row @row-click="dianjixuanzhongXQ" border center bordersize="mini" class="tableComent">
                <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center" width="100"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center" width="100"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center" width="150"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center" width="150"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="singletonWeight" label="单件理重（吨）" align="center" width="120">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center" width="70"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" align="center" width="120">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重(吨)" align="center" width="100">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="factoryWeight" label="出厂过磅净重（吨）" align="center" width="150">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="weighingWeight" label="过磅净重（吨）" align="center" width="120">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="weighingDate" label="实际过磅时间" align="center" width="220" :formatter="dateTimeFormat"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="outNumber" label="出厂车号" align="center" width="120">
                </el-table-column>

                <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" align="center" width="100"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="queueForwardUnit" label="发货单位" align="center" width="130"></el-table-column>
                <!-- <el-table-column :show-overflow-tooltip="true" prop="sceneUser" label="现场人员" align="center" width="200"></el-table-column> -->
              </el-table>
            </div>
            <!--分页-->
            <div class="pags" style="text-align: right">
              <el-pagination background @current-change="handleCurrentChangeXQ" :current-page="pageInfoXQ.pageNo" :page-size="pageInfoXQ.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeXQ" :total="totalXQ"></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- dialogs -->
    <!-- 新增入库计划 -->
    <ruku-plan-dialog v-if="xzVisible" :xzVisible.sync="xzVisible" :title="xzTitle" :xztableData="xztableData" :xiugaiObj="xiugaiObj" :RKData.sync='RKData'></ruku-plan-dialog>

    <!-- 卸车确认 -->
    <xie-che-dialog v-if="xcVisible" :xcVisible.sync='xcVisible' :instockId="instockId" :chepai='chepai' :warehouseId='warehouseId' :customerName="customerName" :customerTaxId="customerTaxId"></xie-che-dialog>
    <!-- 查看单据 -->
    <dj-dialog v-if="CKDJVisible" :CKDJVisible.sync='CKDJVisible' :instockId="instockId"></dj-dialog>
  </div>
</template>

<script>
import {
  JfgetThreadExpList,
  zidianKuwei,
  JfdeleteThreadExp,
  JfgetThreadDetailExpList,
  JfgetThreadDetailExpWN
} from '@/api/wms-access'
import {
  getRelationCustomer,
  getUsersByTenantCode,
  zidian,
  getWeighingMethodList
} from '@/api/wms-stock'
import {
  dateTimeFormat
} from '@/utils/util'
import { exportExcel } from '@/utils/fileDown.js'
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import RukuPlanDialog from './rukuPlanDialog.vue'
import XieCheDialog from './xieCheDialog.vue'
import djDialog from '../dialog/DJindex.vue'

export default {
  components: { RukuPlanDialog, XieCheDialog, djDialog },
  data () {
    return {
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      formData: {
        instockPlateNumber: '',
        primaryCustomerName: '',
        customerName: '',
        createTimeStart: '',
        createTimeEnd: '',
        driverName: '',
        customerTaxId: '',
        primaryCustomerTaxId: '',
        instockNo: '',
        arrivalMethod: ''
      },
      HwTypeData: [],
      totalXQ: 0,
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      pageInfoXQ: {
        pageSize: 20,
        pageNo: 1
      },
      total: 0,
      detailsData: [], // 详情数据
      RKData: [], //
      btnFlg: [],
      tableData: [],
      totalAllWeight: '',
      totalNumber: '',
      btnIdArr: [
        '00ZP001B001',
        '00ZP001B002',
        '00ZP001B003',
        '00ZP001B004',
        '00ZP001B005',
        '00ZP001B006',
        '00ZP001B007',
        '00ZP001B008',
        '00ZM090100'
      ],
      detailsH: '200px',
      h: '500px',
      xuanzhongArr: null,
      xuanzhongArrXQ: null,
      xcLoading: false,
      inWeighingMethod: '',
      xzVisible: false,
      xzTitle: '新增入库计划',
      xztableData: [],
      xcVisible: false,
      xiugaiObj: {},
      xieCheTable: [],
      chepai: '',
      instockId: '',
      warehouseId: '',
      arrivalMethodData: [
        {
          value: '1',
          label: '火运'
        },
        {
          value: '2',
          label: '汽运'
        },
        {
          value: '3',
          label: '船运'
        }
      ],
      // 查看单据
      CKDJVisible: false,
      customerName: '',
      customerTaxId: ''
    }
  },
  methods: {
    // 查看单据
    lookImg (row) {
      this.CKDJVisible = true
      this.instockId = row.instockId
    },
    // 总重量
    JfgetThreadDetailExpWNs () {
      JfgetThreadDetailExpWN(
        {
          instockId: this.xuanzhongArr.instockId
        }
      )
        .then(res => {
          this.totalAllWeight = res.totalAllWeight
          this.totalNumber = res.totalNumber
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    xc () {
      if (this.detailsData.length == 0) {
        this.$message({ message: '暂无数据', type: 'error' })
      } else if (this.xuanzhongArr.primaryCustomerName == '' && this.xuanzhongArr.customerName == '') {
        this.$message.error('请先完善信息')
      } else {
        this.customerName = this.xuanzhongArr.customerName
        this.customerTaxId = this.xuanzhongArr.customerTaxId
        this.chepai = this.xuanzhongArr.instockPlateNumber
        this.instockId = this.xuanzhongArr.instockId
        this.warehouseId = this.xuanzhongArr.warehouseId
        this.xcVisible = true
      }
    },
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      this.JfgetThreadDetailExpLists()
    },
    xinzeng () {
      this.xzVisible = true
      this.xzTitle = '新增入库计划'
    },
    xiugai () {
      if (this.tableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      this.xzVisible = true
      this.xzTitle = '修改入库计划'
      this.xiugaiObj = this.xuanzhongArr
      this.xztableData = this.detailsData
    },
    shanchu () {
      if (this.tableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      const that = this
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        JfdeleteThreadExp(
          {
            instockIds: this.xuanzhongArr.instockId
          }
        )
          .then(res => {
            DonMessage.success('删除成功')
            that.chaxun()
          })
          .catch(error => {
            DonMessage.error(error.message)
          })
      })
    },
    chaxun () {
      JfgetThreadExpList({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        instockPlateNumber: this.formData.instockPlateNumber,
        primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
        customerTaxId: this.formData.customerTaxId,
        createTimeStart: this.formData.createTimeStart,
        createTimeEnd: this.formData.createTimeEnd,
        driverName: this.formData.driverName,
        instockStatus: 0,
        instockNo: this.formData.instockNo,
        arrivalMethod: this.formData.arrivalMethod
      })
        .then(res => {
          this.tableData = res.list
          if (res.list.length) {
            this.xuanzhongArr = res.list[0]
            this.$nextTick(() => {
              this.$refs.tabref1.setCurrentRow(res.list[0])
            })
            this.JfgetThreadDetailExpLists()
          } else {
            this.detailsData = []
            this.totalAllWeight = 0
            this.totalNumber = 0
            this.totalXQ = 0
          }

          this.total = res.total
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chongzhi () {
      this.formData.instockPlateNumber = ''
      this.formData.primaryCustomerTaxId = ''
      this.formData.customerTaxId = ''
      this.formData.createTimeStart = ''
      this.formData.createTimeEnd = ''
      this.formData.productType = ''
      this.formData.driverName = ''
      this.formData.instockNo = ''
      this.formData.arrivalMethod = ''

      this.chaxun()
    },
    dayin (n) {
      if (this.tableData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        }
        )
        return
      }
      this.$router.push({
        path: '/xiecheDanPrint',
        query: {
          id: this.xuanzhongArr.instockId,
          flag: n// 1为首线lianhe
        }
      })
    },

    handleCurrentChangeXQ (val) {
      this.pageInfoXQ.pageNo = val
      this.JfgetThreadDetailExpLists()
    },
    handleSizeChangeXQ (val) {
      this.pageInfoXQ.pageSize = val
      this.JfgetThreadDetailExpLists()
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    },
    // 货物详情
    JfgetThreadDetailExpLists () {
      JfgetThreadDetailExpList(
        {
          instockId: this.xuanzhongArr.instockId,
          ...this.pageInfoXQ
        }
      )
        .then(res => {
          this.detailsData = res.list
          this.totalXQ = res.total
          this.xuanzhongArrXQ = res.list[0]
          this.JfgetThreadDetailExpWNs()

          this.$nextTick(() => {
            this.$refs.tabref.setCurrentRow(res.list[0])
          })
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    dianjixuanzhongXQ (row) {
      this.xuanzhongArrXQ = {}
      this.xuanzhongArrXQ = row
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          this.RKData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },

    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({
      })
        .then((res) => {
          this.ckData = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    // 现场人员
    getUsersByTenantCodes () {
      getUsersByTenantCode()
        .then(res => {
          this.ryData = res
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型
    zidians () {
      zidian({
        groupNo: 'thread_product_type'
      })
        .then((res) => {
          this.HwTypeData = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取货物计重方式
    getWeighingMethodLists (productType) {
      getWeighingMethodList(
        {
          productType
        }
      )
        .then(res => {
          if (res.length > 0) this.inWeighingMethod = res[0].inWeighingMethod
          if (res[0].inWeighingMethod == 2) {
            this.xiecheRules.weighingWeight[0].required = true
            this.xiecheRules.weighingDate[0].required = true
          } else {
            this.xiecheRules.weighingWeight[0].required = false
            this.xiecheRules.weighingDate[0].required = false
          }
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    daochu () {
      exportExcel(
        this.global.wmsAccessName + '/instockThreadExp/exportMasterAndSummary',
        { ...this.formData, instockStatus: '0' },
        '入库计划'
      )
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/jfRukuPlan')
    this.getRelationCustomerS()
    this.chaxun()
    this.zidians()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let h2 = this.$refs.searchBox2.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = 0.6 * pH - h - 145 + 'px'
    this.detailsH = 0.4 * pH - h2 - 112 + 'px'
  }
}
</script>

<style lang="less" scoped>
.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
.ruKuZuoyeWarp {
  width: 100%;
  position: relative;
}
</style>
